function updateBodyScrollClasses() {
  const y = window.scrollY || document.documentElement.scrollTop || 0;
  document.body.classList.toggle("scrolled", y > 0);

  // Homepage hero or property masthead: same “past the cover” threshold for header styling.
  const topCover =
    document.querySelector(".hero") ?? document.querySelector(".masthead");

  if (!topCover) {
    // No hero/masthead (e.g. legal): keep previous behaviour — solid header once user scrolls.
    document.body.classList.toggle("scrolled-past-top", y > 0);
    return;
  }

  const { bottom } = topCover.getBoundingClientRect();
  const vh = window.innerHeight;
  // Switch a bit before the block fully clears: when its bottom edge crosses ~20% from the
  // viewport top — still in the “tail” of the cover, not only after it’s gone (bottom <= 0).
  const scrolledTriggerY = Math.max(56, Math.round(vh * 0.2));

  document.body.classList.toggle(
    "scrolled-past-top",
    bottom <= scrolledTriggerY,
  );
}

updateBodyScrollClasses();
window.addEventListener("scroll", updateBodyScrollClasses, { passive: true });
window.addEventListener("resize", updateBodyScrollClasses, { passive: true });
